const ROUTES_NAME = {
    HOME: '/home',
    DADOS_CLIENTE: '/dados-cliente',
    LISTA_BENS: '/lista-bens',
    COMBOS: '/combos',
    COBERTURA: '/cobertura',
    RESUMO: '/resumo',
    PERSONALIZAR: '/personalizar',
    DADOS_COMPLEMENTARES: '/dados-complementares',
    RESUMO_SOLICITACAO: '/resumo-solicitacao',
    CONTRATACAO: '/contratacao',
    ACESSO_NEGADO: '/acesso-negado',
    SOLICITACAO_CONTRATACAO: '/solicitacao-contratacao',
    HISTORICO: '/historico',
    ATUALIZAR_ANO_BEM:'/atualizar-ano-bem',
    EMAIL_PDF: '/email-pdf'

};

export default ROUTES_NAME;
